module.exports = __webpack_public_path__ + "static/media/Compras7.7bf9ee3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras7.png
// module id = 2073
// module chunks = 0